import { createFileRoute } from '@tanstack/react-router'

// Proxied through nest-api so the iframe is same-origin and doesn't hit
// CF Access + Cognito hosted-UI (Cognito sets X-Frame-Options: DENY which
// kills iframing). The Worker attaches a CF Access service token when
// calling int-docs upstream.
const INT_DOCS_URL = '/api/int-docs/docs/project/nest/?embed=true'

function HelpCenter() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h1 className="text-lg font-semibold">Internal Docs</h1>
        <a
          href={INT_DOCS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-blue-500 hover:text-blue-400 underline"
        >
          Open in new tab
        </a>
      </div>
      <iframe
        src={INT_DOCS_URL}
        className="flex-1 w-full border-0"
        title="N.E.S.T. Documentation"
      />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/help-center/')({
  component: HelpCenter,
})
